import { Route } from '@angular/router';
import ServiceRoutes from '@app/src/app/modules/service/routes/public/service.routes';
import SolutionRoutes from '@app/src/app/modules/solution/routes/public/solution.routes';
import PostRoutes from '@app/src/app/modules/post/routes/public/post.routes';

export default {
  path: '',
  data: {
    meta: {
      description: 'Umbrella SIE slogan',
    },
  },
  children: [
    {
      path: '',
      data: {
        title: 'Home',
      },
      children: [
        {
          path: '',
          loadComponent: () =>
            import('@app/src/app/modules/default/views/public/home/home').then(
              (m) => m.Home,
            ),
        },
        {
          path: 'home',
          loadComponent: () =>
            import('@app/src/app/modules/default/views/public/home/home').then(
              (m) => m.Home,
            ),
        },
      ],
    },
    {
      path: 'rse',
      loadComponent: () =>
        import('@app/src/app/modules/default/views/public/rse/rse').then(
          (m) => m.Rse,
        ),
      data: {
        title: 'RSE',
      },
    },
    {
      path: 'contact',
      loadComponent: () =>
        import('@app/src/app/modules/default/views/public/contact/contact').then(
          (m) => m.Contact,
        ),
      data: {
        title: 'Contact',
      },
    },
    // {
    //   path: 'about-us',
    //   component: About,
    //   data: {
    //   },
    // },
    ServiceRoutes,
    SolutionRoutes,
    PostRoutes,
  ],
} as Route;
